import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { DISCLAIMER } from "../../../global/variables";
import { getWelcomeText } from "../welcome";
import { WAU_BUTTONS } from "../../feature-buttons";

export const pageConfigWAU: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.QuestionsAboutWeiterbildung),
    welcome: {
        text: getWelcomeText("WAU"),
        disclaimer: DISCLAIMER,
        buttons: WAU_BUTTONS,
    },
};
